import './bootstrap';
import Vue from 'vue'

Vue.component('input-set', require('./components/InputSetComponent.vue').default);
Vue.component('image-upload', require('./components/ImageUploadComponent.vue').default);
Vue.component('images-upload', require('./components/ImagesUploadComponent.vue').default);
Vue.component('inner-link-list', require('./components/InnerLinkListComponent.vue').default);
Vue.component('modal-window', require('./components/ModalWindowComponent.vue').default);
Vue.component('upload-csv', require('./components/UploadCSVComponent.vue').default);


import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();

const app = new Vue({
  el: '#app',

});
